import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchSettings = () => {
  const response = useQuery({
    queryKey: ['referralSettings'],
    queryFn: () => api.referral.fetchSettings(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки реферальной программы',
      type: 'error',
      duration: 9000,
      isClosable: true,
    })
  }

  return response
}
